import type { Trip } from "./types";

const dbName = "viaviva";
const storeName = "trips";
function database() {
  return new Promise<IDBDatabase>((resolve, reject) => {
    const request = indexedDB.open(dbName, 1);
    request.onupgradeneeded = () => request.result.createObjectStore(storeName, { keyPath: "publicId" });
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}
export async function cacheTrip(trip: Trip) {
  const db = await database();
  const transaction = db.transaction(storeName, "readwrite");
  transaction.objectStore(storeName).put(trip);
  await new Promise<void>((resolve, reject) => { transaction.oncomplete = () => resolve(); transaction.onerror = () => reject(transaction.error); });
  db.close();
}
export async function cachedTrip(publicId: string) {
  const db = await database();
  const transaction = db.transaction(storeName, "readonly");
  const request = transaction.objectStore(storeName).get(publicId);
  const result = await new Promise<Trip | null>((resolve, reject) => { request.onsuccess = () => resolve(request.result ?? null); request.onerror = () => reject(request.error); });
  db.close(); return result;
}
